import { ReactNode } from 'react';
import Card from '../../../components/Card';

type HeroCardProps = {
    icon: ReactNode;
    title: string;
    value: string;
};

const HeroCard: React.FC<HeroCardProps> = ({ icon, title, value }) => (
    <Card>
        {icon}
        <div className='detail'>
            <div className='title'>{title}</div>
            <div className='value'>{value}</div>
        </div>
    </Card>
);

export default HeroCard;
